<template>
  <mdb-container fluid class="gp-has-header">
    <div v-show="showMain">
      <data-table queryName="GroupQuery"
                  :actions="actions"
                  :forceQuery="forceQuery"
                  @handleAction="handleRowAction"
                  @forcedRowLoaded="forcedRowLoaded"
                  :nav-links="navLinks"
                  :page-title="capitalize($tc('common.label.group',2)) "
                  title-icon="users-crown"
      />
    </div>
    <div v-if="showGroup && currentGroup">
      <mdb-card>
        <mdb-card-body class="text-left">
          <group-card :group="currentGroup"/>
          <mdb-btn icon="arrow-left" rounded size="sm" @click="cancelShow">
            {{ capitalize($tc("common.label.group", 1)) }} List
          </mdb-btn>
          <mdb-btn icon="database" rounded size="sm" @click="$router.push('/admin/dashboard')">Admin Dashboard</mdb-btn>
          <mdb-btn color="success" icon="arrow-right"
                   rounded size="sm" @click="navToGroup">Go To Group
          </mdb-btn>
          {{ currentGroup.url }}

          <mdb-card v-if="currentGroup.approvalStatus == 'SUBMITTED'">
            <mdb-card-header class="warning-color text-white">
              <h5>Approval Requested</h5>
            </mdb-card-header>
            <mdb-card-body v-if="!showDenyInput">
              <mdb-btn color="success" icon="check" rounded size="sm" @click="approveGroup">Approve</mdb-btn>
              <mdb-btn color="danger" icon="ban" rounded size="sm" @click="showDenyInput = true">Deny</mdb-btn>
            </mdb-card-body>
            <mdb-card-body v-if="showDenyInput">
              <mdb-input v-model="denyReason" placeholder="Denied Reason (user will see this)."></mdb-input>
              <mdb-btn :disabled="!denyReason" color="danger" icon="user-minus" rounded size="sm" @click="denyGroup">
                Deny
              </mdb-btn>
              <mdb-btn color="success" icon="ban" rounded size="sm" @click="showDenyInput = false"> Cancel</mdb-btn>
            </mdb-card-body>
          </mdb-card>

          <mdb-card v-if="currentGroup.approvalStatus == 'DENIED'">
            <mdb-card-header class="danger-color text-white">
              <h5>Group Denied</h5>
            </mdb-card-header>
            <mdb-card-body>
              <mdb-btn color="success" icon="check" rounded size="sm" @click="approveGroup">Approve Now</mdb-btn>
            </mdb-card-body>
          </mdb-card>
          <mdb-input v-model="currentGroup.id" disabled label="ID" type="text"/>
          <mdb-card class="mb-2">
            <mdb-card-header>
              <h5>Enable/Disable</h5>
            </mdb-card-header>
            <mdb-card-body>
              <div v-if="currentGroup.deleteAfter" classs="danger-text">
                <div>Group is slated for deletion after {{ currentGroup.deleteAfter }}</div>
                <mdb-btn color="green" icon="times-circle" rounded size="sm"
                         @click="toggleDelete()">Remove Pending Delete
                </mdb-btn>
              </div>
              <mdb-btn v-if="!currentGroup.deleteAfter" color="danger" icon="trash" rounded size="sm"
                       @click="toggleDelete()">Request Deletion
              </mdb-btn>
              <div v-if="currentGroup.disabled">
                <mdb-badge color="danger">GROUP DISABLED</mdb-badge>
                <mdb-input v-model="currentGroup.disabledReason" disabled label="Disabled Reason" type="text"/>
                <mdb-btn v-if="currentGroup.disabled" icon="plus-circle" rounded size="sm" @click="enable()">Enable
                </mdb-btn>
              </div>
              <div v-if="!currentGroup.disabled">
                <mdb-btn v-if="currentGroup.isPrivate" color="warning" icon="eye" rounded size="sm"
                         @click="toggleProperty('private')">
                  Make Public
                </mdb-btn>
                <mdb-btn v-if="!currentGroup.isPrivate" color="warning" icon="eye-slash" rounded size="sm"
                         @click="toggleProperty('private')">
                  Make Private
                </mdb-btn>
                <mdb-btn color="warning" icon="times-circle" rounded size="sm" @click="disable('Inactivity')">Disable -
                  Inactivity
                </mdb-btn>
                <mdb-btn color="warning" icon="times-circle" rounded size="sm" @click="disable('Payment')">Disable -
                  Payment
                </mdb-btn>
                <mdb-btn color="warning" icon="times-circle" rounded size="sm" @click="disable('Other')">Disable -
                  Other
                </mdb-btn>
              </div>
            </mdb-card-body>
          </mdb-card>

          <mdb-card class="mb-2">
            <mdb-card-header>
              <h5>Owner</h5>
            </mdb-card-header>
            <mdb-card-body>
              <div>
                <avatar :avatar="currentGroup.ownerAvatar" :name="currentGroup.ownerName"/>
                {{ currentGroup.ownerName }}
              </div>
              <div style="clear:both;">
                <mdb-btn v-if="userDetails.isAdmin" icon="search" rounded size="sm"
                         @click="$router.push('/users/'+currentGroup.ownerId)">Owner
                  Details
                </mdb-btn>
                <mdb-btn icon="pencil" color="warning" rounded size="sm"
                         @click="$router.push('/admin/ownerChange/'+ currentGroup.id)">
                  Change Owner
                </mdb-btn>
                <mdb-btn v-if="userDetails.isAdmin" icon="user" color="warning" rounded size="sm" @click="proxyOwner">
                  Proxy Owner
                </mdb-btn>
                <mdb-btn icon="envelope" rounded size="sm"
                         @click="$router.push('/conversations?start='+currentGroup.ownerId)">Message Owner
                </mdb-btn>
              </div>
            </mdb-card-body>
          </mdb-card>

          <mdb-card class="mb-2">
            <mdb-card-header>
              <h5>Add-ons/Features</h5>
            </mdb-card-header>
            <mdb-card-body>

              <mdb-input id="private-checkbox" v-model="currentGroup.isPrivate" disabled label="Is Private?"
                         type="checkbox"/>
              <mdb-input id="disabled-checkbox" v-model="currentGroup.disabled" disabled label="Disabled?"
                         type="checkbox"/>
              <mdb-row>
                <mdb-col col="3">
                  <mdb-input id="free-checkbox" v-model="currentGroup.freeGroup" disabled
                             :label="'Free ' + capitalize($tc('common.label.group',1)) +'?' "
                             type="checkbox"/>
                </mdb-col>
              </mdb-row>
              <mdb-row v-if="config.features.campfire">
                <mdb-col col="3">
                  <mdb-input id="campfire-checkbox" v-model="currentGroup.campfireActive" disabled
                             label="Campfire Active?"
                             type="checkbox"/>
                </mdb-col>
              </mdb-row>
              <mdb-row v-if="config.features.presenter">
                <mdb-col col="3">
                  <mdb-input id="presenter-checkbox" v-model="currentGroup.presenterActive" disabled
                             label="Sumato Active?"
                             type="checkbox"/>
                </mdb-col>
              </mdb-row>
              <mdb-row v-if="config.features.fileStorage">
                <mdb-col col="6">
                  <mdb-input id="files-checkbox" v-model="currentGroup.fileStorageEnabled" disabled
                             label="File Storage Feature?"
                             type="checkbox"/>
                </mdb-col>
              </mdb-row>
              <mdb-row v-if="config.features.jitsi">
                <mdb-col col="6">
                  <mdb-input id="jitsi-checkbox" v-model="currentGroup.jitsiEnabled" disabled
                             label="Jitsi Active?"
                             type="checkbox"/>
                </mdb-col>
              </mdb-row>
              <mdb-row v-if="!currentGroup.freeGroup">
                <mdb-col col="6">
                  <mdb-input id="who-pays" v-model="currentGroup.billingRule" disabled
                             label="Who Pays"
                             type="text"/>
                </mdb-col>
                <mdb-col col="6" v-if="currentGroup.billingRule == 'Members'">
                  <div>
                    <mdb-input id="who-pays" v-model="currentGroup.groupTier" disabled
                               label="Tier"
                               type="text"/>

                    <mdb-btn icon="pencil" rounded size="sm" @click="openTierModal">Change Tier</mdb-btn>

                  </div>
                </mdb-col>
              </mdb-row>

              <mdb-row>
                <mdb-col col="6">
                  <mdb-input id="hide-explore" v-model="currentGroup.hideFromExplore" disabled
                             label="Hide from Explore Page"
                             type="checkbox"/>
                </mdb-col>
              </mdb-row>

              <mdb-row>
                <mdb-col col="6">
                  <mdb-input id="monitor-joins" v-model="currentGroup.sysAdminMonitorJoins" disabled
                             label="Monitor Join Requests on System Dashboard"
                             type="checkbox"/>
                </mdb-col>
              </mdb-row>

              <mdb-btn :color="currentGroup.freeGroup ? 'warning' :'success'"
                       :icon="currentGroup.freeGroup ? 'toggle-off' :'toggle-on'" rounded
                       size="sm"
                       @click="toggleProperty('freeGroup')">Toggle Free
              </mdb-btn>
              <mdb-btn :color="currentGroup.campfireActive ? 'warning' :'success'"
                       :icon="currentGroup.campfireActive ? 'toggle-off' :'toggle-on'" rounded
                       size="sm"
                       v-if="config.features.campfire"
                       @click="toggleProperty('campfireActive')">Toggle Campfire
              </mdb-btn>
              <mdb-btn :color="currentGroup.presenterActive ? 'warning' :'success'"
                       :icon="currentGroup.presenterActive ? 'toggle-off' :'toggle-on'" rounded
                       size="sm"
                       v-if="config.features.presenter"
                       @click="toggleProperty('presenterActive')">Toggle Sumato
              </mdb-btn>
              <mdb-btn :color="currentGroup.fileStorageEnabled ? 'warning' :'success'"
                       :icon="currentGroup.fileStorageEnabled ? 'toggle-off' :'toggle-on'" rounded
                       size="sm"
                       v-if="config.features.fileStorage"
                       @click="toggleProperty('fileStorageEnabled')">Toggle File Feature
              </mdb-btn>
              <mdb-btn :color="currentGroup.jitsiEnabled ? 'warning' :'success'"
                       :icon="currentGroup.jitsiEnabled ? 'toggle-off' :'toggle-on'" rounded
                       size="sm"
                       v-if="config.features.jitsi"
                       @click="toggleProperty('jitsiEnabled')">Toggle Jitsi
              </mdb-btn>
              <mdb-btn :color="currentGroup.hideFromExplore ? 'warning' :'success'"
                       :icon="currentGroup.hideFromExplore ? 'toggle-off' :'toggle-on'" rounded
                       size="sm"
                       @click="toggleProperty('hideFromExplore')">Toggle Hide From Explore
              </mdb-btn>
              <mdb-btn :color="currentGroup.sysAdminMonitorJoins ? 'warning' :'success'"
                       :icon="currentGroup.sysAdminMonitorJoins ? 'toggle-off' :'toggle-on'" rounded
                       size="sm"
                       @click="toggleProperty('sysAdminMonitorJoins')">Toggle Monitor Joins
              </mdb-btn>
              <mdb-btn rounded icon="toggle-on"
                       size="sm" v-if="!currentGroup.freeGroup"
                       @click="toggleProperty('billingRule')">Toggle Who Pays
              </mdb-btn>
              <div>
                <mdb-btn icon="copy" rounded size="sm" @click="cloneGroup">Clone
                  {{ capitalize($tc("common.label.group", 1)) }}
                </mdb-btn>
              </div>
            </mdb-card-body>
          </mdb-card>
          <mdb-card class="mb-2">
            <mdb-card-header>
              <h5>Forum</h5>
            </mdb-card-header>
            <mdb-card-body>
              <div>Current Provider: {{ currentGroup.forumProvider }}</div>
              <mdb-btn @click="toggleProperty('forumProvider')" rounded icon="toggle-on" size="sm">
                <span v-if="currentGroup.forumProvider=='INTERNAL'">Switch to Discourse</span>
                <span v-if="currentGroup.forumProvider=='DISCOURSE'">Switch to Internal</span>
              </mdb-btn>
            </mdb-card-body>
          </mdb-card>

          <mdb-card class="mb-4" v-if="allTags && allTags.length > 0">
            <mdb-card-header>
              <h5>Tags</h5>
            </mdb-card-header>
            <mdb-card-body>
              <div>
                <mdb-chip v-for="tag in currentGroup.tags" :key="tag.id">{{ tag.name }}</mdb-chip>
              </div>
              <mdb-btn icon="pencil" rounded size="sm" @click="openTagModal">Edit Tags</mdb-btn>
            </mdb-card-body>
          </mdb-card>
          <mdb-card class="mb-4" v-if="userDetails.isAdmin">
            <mdb-card-header>
              <h5>Other Info</h5>
            </mdb-card-header>
            <mdb-card-body>
              <div v-if="config.brands && config.brands.length >0">
                <label for="brand">Brand/Affiliate Program</label>
                <select id="brand" v-model="currentGroup.brand" class="browser-default custom-select">
                  <option value="NONE">None</option>
                  <option v-for="brand in config.brands" :key="brand.id" :value="brand.id">{{ brand.name }}</option>
                </select>
              </div>

              <mdb-row>
                <mdb-col col="4">
                  <mdb-input v-model="currentGroup.prevEvents" :step="1" disabled
                             :label="'Prior Platform ' + capitalize($tc('common.label.event',2))"
                             type="number"/>
                </mdb-col>
                <mdb-col col="2">
                  <mdb-btn id="button-addon1" color="default" floating icon="pencil" size="sm" tag="a"
                           @click="showPrevEventsModal = true"/>
                </mdb-col>
              </mdb-row>
              <mdb-input v-model="currentGroup.createDate" disabled label="Date Created" type="text"/>
              <mdb-input v-model="currentGroup.balanceDue" disabled label="Balance Due" type="text"/>
              <mdb-input v-model="currentGroup.lastBilled" disabled label="Last Billed" type="text"/>
              <mdb-input v-model="currentGroup.paidThrough" disabled label="Paid Through" type="text"/>
              <mdb-input v-model="currentGroup.members" disabled
                         :label="'Active ' + capitalize($tc('common.label.member',2))" type="text"/>
              <mdb-input v-model="currentGroup.completedEvents" disabled
                         :label="'Completed ' + capitalize($tc('common.label.event',2))" type="text"/>
            </mdb-card-body>
          </mdb-card>
        </mdb-card-body>
      </mdb-card>
    </div>

    <mdb-modal v-if="showTierModal" @close="showTierModal = false">
      <mdb-modal-header class="secondary-color">
        <h5>Choose a Tier</h5>
      </mdb-modal-header>
      <mdb-modal-body class="text-left">
        <div v-for="tier in tiers" :id="tier.value">
          <mdb-btn class="w-100" size="sm" icon="check" color="secondary" @click="setTier(tier.value)">{{tier.text}}</mdb-btn>
        </div>
        <mdb-btn color="warning" icon="times-circle" @click="showTierModal = false">Cancel</mdb-btn>
      </mdb-modal-body>
    </mdb-modal>



    <mdb-modal v-if="showTagModal" @close="showTagModal = false">
      <mdb-modal-header class="secondary-color">
        <h5>Tags</h5>
      </mdb-modal-header>
      <mdb-modal-body class="text-left">
        <div v-for="tag in tagEdit" :id="tag.id">
          <mdb-input :id="'checkbox-'+tag.id"
                     v-model="tag.selected"
                     :label="tag.name"
                     type="checkbox"/>
        </div>
        <mdb-btn color="success" icon="save" @click="saveTags">Save</mdb-btn>
        <mdb-btn color="warning" icon="times-circle" @click="showTagModal = false">Cancel</mdb-btn>
      </mdb-modal-body>
    </mdb-modal>

    <mdb-modal v-if="cloneModal" @close="cloneModal = false">
      <mdb-modal-header class="secondary-color">
        <h5>Clone Options</h5>
      </mdb-modal-header>
      <mdb-modal-body class="text-left">

        <mdb-input v-model="cloneOptions.name"
                   label="New Name"
                   type="text"/>
        <gp-select :dataObj="cloneOptions" :possible-values="cloneOwnerRules" :required="true"
                   label="Type" propertyName="ownerRule"/>
        <gp-select v-if="userDetails.isAdmin" :dataObj="cloneOptions" :possible-values="tenants" :required="true"
                   label="Tenant" propertyName="tenant"/>

        <mdb-btn color="success" icon="save" @click="doClone">Clone</mdb-btn>
        <mdb-btn color="warning" icon="times-circle" @click="cloneModal = false">Cancel</mdb-btn>
      </mdb-modal-body>
    </mdb-modal>

    <mdb-modal v-if="showPrevEventsModal" @close="showPrevEventsModal = false">
      <mdb-modal-header class="secondary-color">
        <h5>Completed {{ capitalize($tc('common.label.event', 2)) }} on Prior Platform</h5>
      </mdb-modal-header>
      <mdb-modal-body class="text-left">
        <mdb-input v-model="prevEvents"
                   :step="1"
                   :label="'Prior ' + capitalize($tc('common.label.event',1)) + ' Count'"
                   type="number"/>
        <mdb-btn color="success" icon="save" @click="savePrevEvents">Save</mdb-btn>
        <mdb-btn color="warning" icon="times-circle" @click="showPrevEventsModal = false">Cancel</mdb-btn>
      </mdb-modal-body>
    </mdb-modal>

  </mdb-container>
</template>

<script>
import dataTable from '../common/DataTableAdvanced'
import GroupCard from "../group/Card";
import gpSelect from "../common/GPSelect";
import {
  mdbBadge,
  mdbBtn,
  mdbCard,
  mdbCardBody,
  mdbCardHeader,
  mdbChip,
  mdbCol,
  mdbContainer,
  mdbIcon,
  mdbInput,
  mdbModal,
  mdbModalBody,
  mdbModalHeader,
  mdbRow
} from 'mdbvue';
import api from "../../services/groupsPlaceApi";
import Avatar from "../common/Avatar";

export default {
  name: 'admin-group',
  components: {
    Avatar,
    mdbContainer, mdbBtn,
    mdbBadge,
    mdbCard,
    mdbCardHeader,
    mdbCardBody,
    mdbInput,
    mdbIcon,
    mdbChip,
    mdbModal,
    mdbModalHeader,
    mdbModalBody,
    mdbRow,
    mdbCol,
    dataTable,
    GroupCard,
    gpSelect
  },
  computed: {
    config: function () {
      return this.$store.state.settings
    },
    userDetails: function () {
      return this.$store.state.userDetails
    },
    currentBrand: function () {
      if (!this.currentGroup) return null
      return this.currentGroup.brand
    },
    settings: function () {
      return this.$store.state.settings
    }
  },
  watch: {
    currentBrand: function (newBrand, oldBrand) {
      if (oldBrand && newBrand && this.currentGroup) {
        this.$store.dispatch("setExecuting", true)
        api.post("/admin/setBrand", {group: this.currentGroup.id, brand: this.currentGroup.brand}).then(
          () => {
            this.$notify.success({message: "Brand successfully changed.", timeOut: 3000})
          },
          (error) => {
            this.$notify.error({message: error.response.data, timeOut: 10000})
          }).then(() => {
          this.$store.dispatch("setExecuting", false)
        })
      }
    }
  },
  data() {
    return {
      saveScroll: 0,
      actions: [
        {name: "edit", label: "Edit", icon: "pencil", class: "text-success"},
        {name: "visit", label: "Visit Group", icon: "chevron-right", class: "text-primary"},
        {name: "owner", label: "Owner Details", icon: "user", class: "text-primary"}
      ],
      cloneOwnerRules: [{text: "Make ME the Owner", value: "me"},
        {text: "Keep the original owner", value: "keep"}
      ],
      navLinks: [
        {target: '/admin/dashboard', label: 'Admin Dashboard', icon: 'database'}
      ],
      forceQuery: null,
      currentGroup: null,
      showGroup: false,
      showMain: false,
      showPrevEventsModal: false,
      prevEvents: 0,
      newPlan: null,
      showDenyInput: false,
      denyReason: "",
      cloneModal: false,
      showTagModal: false,
      showTierModal: false,
      tagEdit: [],
      allTags: [],
      tenants: [],
      cloneOptions: {
        name: "",
        ownerRule: "keep",
        tenant: null
      },
      tiers: []
    }
  },
  mounted() {
    if (this.$route.params.id) {
      this.forceQuery = "id:" + this.$route.params.id
    } else this.showMain = true

    if (this.userDetails.isAdmin) {

      api.get("/tenant/list?max=150", {}).then(
        (results) => {
          for (let tenant of results.data.rows) {
            let row = {value: tenant.id, text: tenant.name}
            this.tenants.push(row)
          }
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 20000})
        })
    }
    api.get("/admin/planTiers").then(
      (results) => {
        this.tiers = results.data
      },
      (error) => {
        this.$notify.error({message: "Error fetching tiers.", timeOut: 3000})
      }).then(() => {
    })
  },
  methods: {
    openTierModal: function() {
      this.showTierModal = true
    },
    setTier: function (groupTier) {
      this.$store.dispatch("setExecuting", true)
      this.showTierModal = false
      api.post("/admin/setGroupTier/" + this.currentGroup.id, {groupTier: groupTier}).then(
        (results) => {
          this.currentGroup.groupTier = results.data.name
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 20000})
          this.showTierModal = true
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    openTagModal: function () {
      this.tagEdit = [];
      for (let i = 0; i < this.allTags.length; i++) {
        let tag = {id: this.allTags[i].id, name: this.allTags[i].name, selected: false}
        for (let j = 0; j < this.currentGroup.tags.length; j++) {
          if (this.currentGroup.tags[j].id == tag.id) tag.selected = true
        }
        this.showTagModal = true
        this.tagEdit.push(tag)
      }
    },
    loadAllTags: function () {
      api.get("/public/allTags?tenant=" + this.currentGroup.tenantId).then(
        (results) => {
          this.allTags = results.data
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 20000})
        })
    },
    toggleDelete: function () {
      this.$store.dispatch("setExecuting", true)
      api.post("/admin/toggleDelete/" + this.currentGroup.id, {}).then(
        (results) => {
          this.currentGroup.deleteAfter = results.data.deleteAfter
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 20000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    toggleProperty: function (prop) {
      this.$store.dispatch("setExecuting", true)
      api.post("/admin/toggleProperty/" + this.currentGroup.id, {property: prop}).then(
        () => {
          if (prop == "billingRule") this.currentGroup[prop] = (this.currentGroup[prop] == "Owner" ? "Members" : "Owner")
          else if (prop == "private") {
            this.currentGroup.isPrivate = !this.currentGroup.isPrivate
            this.currentGroup.approvalStatus = "APPROVED"
          } else if (prop == "forumProvider") {
            if (this.currentGroup.forumProvider == "INTERNAL") this.currentGroup.forumProvider = "DISCOURSE"
            else this.currentGroup.forumProvider = "INTERNAL"
          } else this.currentGroup[prop] = !this.currentGroup[prop]
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 20000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    cloneGroup: function () {
      this.cloneOptions.tenant = this.config.tenantId
      this.cloneOptions.group = this.currentGroup.id
      this.cloneModal = true
    },
    doClone: function () {
      this.$store.dispatch("setExecuting", true)
      this.cloneModal = false
      api.post("/admin/cloneGroup/", this.cloneOptions).then(
        (results) => {
          window.open(results.data.groupUrl, '_blank');
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 20000})
          this.cloneModal = true
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    enable: function () {
      this.$store.dispatch("setExecuting", true)
      api.post("/admin/enableGroup/" + this.currentGroup.id, {}).then(
        (results) => {
          this.currentGroup.disabled = false
          this.currentGroup.disabledReason = null
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 20000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    disable: function (reason) {
      this.$store.dispatch("setExecuting", true)
      api.post("/admin/disableGroup/" + this.currentGroup.id + "?reason=" + reason, {}).then(
        (results) => {
          this.currentGroup.disabled = true
          this.currentGroup.disabledReason = reason
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 20000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    approveGroup: function (reason) {
      this.$store.dispatch("setExecuting", true)
      api.post("/admin/approveGroup/" + this.currentGroup.id, {}).then(
        (results) => {
          this.currentGroup.approvalStatus = "APPROVED"
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 20000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    denyGroup: function (reason) {
      this.$store.dispatch("setExecuting", true)
      api.post("/admin/denyGroup", {id: this.currentGroup.id, denyReason: this.denyReason}).then(
        (results) => {
          this.currentGroup.approvalStatus = "DENIED"
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 20000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    proxyOwner: function () {
      this.$router.push("/users/" + this.currentGroup.ownerId + "/proxy")
    },
    cancelShow: function () {
      let from = this.$route.query.from
      if (from) {
        if (from == "dashboard") this.$router.push("/admin/dashboard")
        if (from == "user") this.$router.push("/users/" + this.currentGroup.ownerId)
      } else {
        this.showMain = true
        this.currentGroup = null
        this.showGroup = false
        this.newPlan = null
        if (this.$route.params.id) this.$router.replace("/admin/group")
        this.$nextTick().then(() => {
          window.scrollTo(0, this.saveScroll)
          this.saveScroll = 0
        });
      }
    },
    forcedRowLoaded(row) {
      this.forceQuery = null
      this.currentGroup = row
      this.openGroup(row)
    },
    handleRowAction(row, action) {
      if (action == "edit") this.openGroup(row)
      if (action == "visit") {
        this.currentGroup = row
        this.navToGroup()
      }
      if (action == "owner") this.$router.push('/users/' + row.ownerId)
    },
    openGroup: function (row) {
      this.showMain = false
      this.currentGroup = row
      this.prevEvents = this.currentGroup.prevEvents
      if (!this.currentGroup.isPrivate) this.currentGroup.homeUrl = "/group/" + this.currentGroup.id
      this.showGroup = true
      this.saveScroll = window.scrollY
      this.loadAllTags()
      window.scrollTo(0, 0)
    },
    saveTags: function () {
      this.showTagModal = false
      this.$store.dispatch("setExecuting", true)
      api.post("/admin/setTags/", {group: this.currentGroup.id, tags: this.tagEdit}).then(
        (results) => {
          this.currentGroup.tags = results.data
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 20000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    navToGroup: function () {
      if (this.currentGroup.tenantUrl != this.config.frontEndUrl) {
        window.open(this.currentGroup.tenantUrl + this.currentGroup.homeUri, "_blank")
      } else this.$router.push(this.currentGroup.homeUri)
    },
    savePrevEvents: function () {
      this.showPrevEventsModal = false
      this.$store.dispatch("setExecuting", true)
      api.post("/admin/prevEvents/", {group: this.currentGroup.id, count: this.prevEvents}).then(
        (results) => {
          this.currentGroup.prevEvents = this.prevEvents
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 20000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    }
  }
};
</script>
